import * as z from "zod"
import { InstructionUsage, AircraftType, DayOfWeek } from "@prisma/client"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]))

export const InstructionModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  name: z.string().nullish(),
  usage: z.nativeEnum(InstructionUsage),
  aircraft_type: z.nativeEnum(AircraftType).nullish(),
  airline_product: z.string().nullish(),
  schedule: z.nativeEnum(DayOfWeek).array(),
  flight_number: z.string().nullish(),
  provider_id: z.string(),
  airport_id: z.string(),
  /**
   * [Address]
   */
  delivery_address: jsonSchema,
  booking_instructions: z.string().nullish(),
  dropoff_instructions: z.string().nullish(),
  dropoff_contact_id: z.number().int().nullish(),
  from_dock_hours: z.number().int().nullish(),
  to_dock_hours: z.number().int().nullish(),
  cutoff_at_hours_before: z.number().int().nullish(),
  cutoff_at_time: z.date().nullish(),
  cutoff_at_time_days_before: z.number().int().nullish(),
})
